import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { CompatModalsComponent } from './compat-modals.component';

@NgModule({
  imports: [UiModule],
  declarations: [CompatModalsComponent],
  entryComponents: [CompatModalsComponent],
})
export class CompatModalsModule {}
